import { createStore } from "jotai";

// create dashboard level store with defaults if any
export function buildDashboardStore() {
  return createStore();
}

// this can also happen inside the component with a memo
// store should only be created on first render
